import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-KeywodsShape",
  "use": "svg-icon-KeywodsShape-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"svg-icon-KeywodsShape\"><path d=\"M21.5 21.5l-5-5.5c1.5-1.5 2.5-3.7 2.5-6 0-4.7-3.8-8.5-8.5-8.5S2 5.3 2 10s3.8 8.5 8.5 8.5c1.8 0 3.5-.6 4.9-1.5l5 5.5 1.1-1zM4.9 14.2h6.6v-1.5H4.1c-.2-.6-.4-1.1-.5-1.8h11.9V9.5h-12c0-.6.2-1.2.4-1.8h9.6V6.3H4.6C5.8 4.3 8 3 10.5 3c3.9 0 7 3.1 7 7s-3.1 7-7 7c-2.3 0-4.3-1.1-5.6-2.8z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol